<template>
    <div class="container">
        <div class="col-md-12">
            <boton-atras :nombre_ruta="'Menu'"/>
        </div>
        <div class="container text-center mb-5">
          <h1 class="bold300 text-uppercase" style=" font-weight:500;">Sistema de Recursos Federales Transferidos</h1>
        </div>
        <!-- <nav>
          <div class="nav nav-movil nav-tabs d-none" id="nav-tab" role="tablist">
              <a
                  class="nav-link"
                  @click="itemActive1 = false, itemActive2 = true, itemActive3 = false"
                  :class="[
                    (!modoDark_var && itemActive2 && !itemActive1)? 'active' : '',
                    (modoDark_var && itemActive2 && !itemActive1)? 'DarkActive active' : '',
                    (modoDark_var && itemActive2==false && (itemActive1))? 'darkInactivo' : ''
                  ]"
                  id="nav-normFinanciera-tab"
                  data-toggle="tab"
                  href="#nav-normFinanciera"
                  role="tab"
                  aria-controls="nav-normFinanciera"
                  aria-selected="false"
                  >
                  <span class="verPc"><p class="m-0">Informes Trimestrales del SRFT</p></span><span class="verMovil"><p class="m-0">Informes SRFT</p></span>
              </a>
          </div>
        </nav> -->
        <div class="tab-content" id="nav-tabContent">
            <div :class="[(itemActive2 && !itemActive1 && !itemActive3)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-normFinanciera" role="tabpanel" aria-labelledby="nav-normFinanciera-tab">
              <div class="card">
                  <div class="card-body-pe">
                    <SRFT v-if="itemActive2"/>
                  </div>
              </div>

            </div>
        </div>


    </div>
  </template>
  <script>
  import { mapState } from "vuex";
  import('@/assets/css/tab.css');
  import botonAtras from '../../button-atras.vue'
  import PE2024_2001 from './Presupuesto-de-Egresos.vue'
  import SRFT from './sistema-recursos-fdrles-transf.vue'
  import SFU from './sistema-formato-unico-shcp.vue'


  export default ({
    name: 'Tab',
    computed:{ ...mapState(['modoDark_var']) },
    components: {botonAtras, SRFT },

    data() {
      return{
        itemActive1: false,
        itemActive2: true,
        itemActive3: false,
      }
    },
  })
  </script>
  <style scoped>
  .card{
    background-color: transparent;
    margin-bottom: 7rem;
  }
  </style>
